// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3jHro","name":"ConsentHeader_name__1tdPd","birthday":"ConsentHeader_birthday__1yXm1","skeleton":"ConsentHeader_skeleton__3EfYG"};